import React from 'react'
import { IntlContextConsumer, changeLocale } from 'gatsby-plugin-react-intl'
import { breakpoint, color } from '@configs/utilities'
import styled from 'styled-components'
import _find from 'lodash/find'
import enFlag from '@assets/images/languages/en.png'
import esFlag from '@assets/images/languages/es.png'
import ptFlag from '@assets/images/languages/pt.png'
import frFlag from '@assets/images/languages/fr.png'
import deFlag from '@assets/images/languages/de.png'
import itFlag from '@assets/images/languages/it.png'
import plFlag from '@assets/images/languages/pl.png'
import nlFlag from '@assets/images/languages/nl.png'
import srFlag from '@assets/images/languages/sr.png'

const LanguageSelector = ({ mobile = false }) => {
  const options = [
    {
      value: 'en',
      label: 'English (US)',
      mobileLabel: 'EN (US)',
      width: '105px',
      mobileWidth: '80px',
      flag: enFlag,
      beta: false,
    },
    { value: 'es', label: 'Español', mobileLabel: 'ES', width: '75px', mobileWidth: '45px', flag: esFlag, beta: false },
    {
      value: 'pt',
      label: 'Português',
      mobileLabel: 'PT',
      width: '90px',
      mobileWidth: '45px',
      flag: ptFlag,
      beta: false,
    },
    {
      value: 'fr',
      label: 'Français',
      mobileLabel: 'FR',
      width: '80px',
      mobileWidth: '45px',
      flag: frFlag,
      beta: false,
    },
    { value: 'de', label: 'Deutsch', mobileLabel: 'DE', width: '77px', mobileWidth: '45px', flag: deFlag, beta: false },
    {
      value: 'it',
      label: 'Italiano',
      mobileLabel: 'IT',
      width: '70px',
      mobileWidth: '45px',
      flag: itFlag,
      beta: false,
    },
    { value: 'pl', label: 'Polski', mobileLabel: 'PL', width: '60px', mobileWidth: '45px', flag: plFlag, beta: false },
    {
      value: 'nl',
      label: 'Nederlands',
      mobileLabel: 'NL',
      width: '100px',
      mobileWidth: '45px',
      flag: nlFlag,
      beta: false,
    },
    { value: 'sr', label: 'Srpski', mobileLabel: 'SR', width: '65px', mobileWidth: '45px', flag: srFlag, beta: false },
  ]

  const onChangeLocale = (value) => {
    window.Intercom('update', { language_override: value })
    changeLocale(value)
  }

  const getCurrentLanguageObject = (value) => {
    return _find(options, ['value', value])
  }

  return (
    <IntlContextConsumer>
      {({ language: currentLocale }) => {
        const localeObject = getCurrentLanguageObject(currentLocale)
        return (
          <Wrapper>
            <ImageWrapper>
              {localeObject.beta && <sup>BETA</sup>}
              <img src={localeObject.flag} alt="" />
            </ImageWrapper>
            <SelectWrapper>
              <select
                value={currentLocale}
                onChange={(event) => onChangeLocale(event.target.value)}
                name="lang"
                style={mobile ? { width: localeObject.mobileWidth } : { width: localeObject.width }}
              >
                {options.map((item, index) => {
                  return (
                    <option key={index} value={item.value}>
                      {mobile ? item.mobileLabel : item.label}
                    </option>
                  )
                })}
              </select>
            </SelectWrapper>
          </Wrapper>
        )
      }}
    </IntlContextConsumer>
  )
}

export default LanguageSelector

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  //opacity: 0.5;
`

const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 22px;

  sup {
    color: ${color.yellow};
    font-size: 10px;
    font-weight: 700;
    margin-right: 5px;
  }

  @media screen and (min-width: ${breakpoint.xl}) {
    height: 18px;
  }

  img {
    width: 20px;
    margin-right: 3px;
  }
`
const SelectWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  select {
    width: auto;
    cursor: pointer;
    font-size: 14px;
    outline: none;
    border: none;
  }
`
